import axios from 'axios';
import { CACHE_MANAGER_REST_API_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
    'vf-trace-transaction-id': crypto.randomUUID(),
    ...commonRequestHeaders(),
  };
};

export const readCache = async (keyRef, key, encode = false, hash = false) => {
  const response = await axios.get(`${CACHE_MANAGER_REST_API_URL}/read`, {
    params: { keyRef, key, encode, hash },
    headers: getHeaders(),
  });
  return response.data;
};

export const writeCache = async (key, data, ttl) => {
  const response = await axios.get(`${CACHE_MANAGER_REST_API_URL}/write`, {
    params: { key, data, ttl },
    headers: getHeaders(),
  });
  return response.data;
};

export const invalidateCache = async (keyRef, key, encode = false, hash = false) => {
  const response = await axios.get(`${CACHE_MANAGER_REST_API_URL}/invalidate`, {
    params: { keyRef, key, encode, hash },
    headers: getHeaders(),
  });
  return response.data;
};
